<template>
<b-container id="body" fluid>
<b-row>
   <b-col> 
        Admin Dashboard
   
    <b-row>
        <b-col>
            <table><tr><td><input id="email" type="text"></td><td>
                <input id="password" type="text" /></td><td>
                <button @click="createUser">create user</button></td></tr></table>
        </b-col>
    </b-row>
    <b-row>
        <b-col id="list_users">
        </b-col>
    </b-row>
   </b-col>
   <b-col>
    <b-row>
    <button style="border: none; background:none;" @click='logout'><i class="fas fa-sign-out-alt"></i>Sign-Out</button>
    </b-row>
   </b-col>
</b-row>
</b-container>
</template>
<script>
import {db, auth} from '../firebase'

export default {

  data () {
    return {
      
    }
  },
  methods:{
      logout: function(){
          auth.signOut().then(() => {
            this.$router.replace({name: "adminlogin"});
            }).catch((error) => {
            // An error happened.
            });
      },
      createUser: function(){
        var email = document.getElementById('email').value 
        var password = document.getElementById('password').value

        if(email !== "" && password !== ""){
        auth.createUserWithEmailAndPassword(email, password)
        .then((userCredential) => {
            console.log(userCredential)
            if(db.collection('users').add({
              email: email,
              password: password
              })){
            console.log("success");
            document.getElementById('email').value = ""
            document.getElementById('password').value =""
           this.getUsers()
          }
        })
        }else{
          alert("Enter an Email & Password")
        }
      },
      getUsers: function(){
        console.log('get users')
      db.collection('users')
      .get().then((query) => {
        const newul = document.createElement('ul')

        query.forEach((doc) => {
          newul.innerHTML += '<li style="list-style-type: none;"><button style="border: none; background:none;" name="'+ doc.data().email +'" value="'+ doc.data().password +'" class="delete"><i class="fas fa-window-close"></i></button>'+ doc.data().email +" "+"<input style='border: none; color: black;' type='password' value='"+ doc.data().password+"' readonly></li>"
          
          })

        document.getElementById('list_users').innerHTML = ''
        document.getElementById('list_users').appendChild(newul)

         document.querySelectorAll('.delete').forEach(
            item => {
              item.addEventListener('click', this.deleteUser)
            })

      })
      },
      deleteUser: function(event){
        var email = event.target.name
        var password = event.target.value
        var adminEmail = "aimslibadmin@gmail.com"
        var adminPass = "aims2000"
       console.log(email+" "+password)

       var deleteThis = db.collection('users').where('email', '==', email)
              
                deleteThis.get().then(
                  function(querySnapshot){
                    querySnapshot.forEach(function(doc){
                      console.log(doc)
                      doc.ref.delete()
                      console.log('deleted')
                    })
                    
        auth.signInWithEmailAndPassword(email, password).then(user =>
        {

            auth.currentUser.delete().then(function() {

              
                  auth.signInWithEmailAndPassword(adminEmail, adminPass).then(function(){
                 
                    db.collection('users')
                      .get().then((query) => {
                        const newul = document.createElement('ul')

                        query.forEach((doc) => {
                          newul.innerHTML += '<li><button name="'+ doc.data().email +'" value="'+ doc.data().password +'" class="delete"><i class="fas fa-window-close"></i></button>'+ doc.data().email +" "+ doc.data().password+'</li>'
                          
                          })

                        document.getElementById('list_users').innerHTML = ''
                        document.getElementById('list_users').appendChild(newul)

                        document.querySelectorAll('.delete').forEach(
                            item => {
                              item.addEventListener('click', this.deleteUser)
                            })

                      })
                    })

                  }
                  )

              // User deleted.
            }).catch((error) => {
              console.log(error);
            })
        }).catch((error) => {
        console.log(error);
      })
      }
 
},
 mounted:function(){
    this.getUsers()
  }

}
</script>
<style scoped>
ul{
  list-style-type: none;
}
</style>
